exports = module.exports = require("../../css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.pnlm-ui .pnlm-about-msg {\n  display: none !important;\n}\n.pnlm-ui .pnlm-orientation-button {\n  display: none !important;\n}\n", "", {"version":3,"sources":["D:/doc/font_read/node_modules/vue-pannellum/src/vue-pannellum.vue"],"names":[],"mappings":";AACA;EACE,yBAAyB;CAC1B;AACD;EACE,yBAAyB;CAC1B","file":"vue-pannellum.vue","sourcesContent":["\n.pnlm-ui .pnlm-about-msg {\n  display: none !important;\n}\n.pnlm-ui .pnlm-orientation-button {\n  display: none !important;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-35f03bd8","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./node_modules/vue-pannellum/src/vue-pannellum.vue
// module id = seS4
// module chunks = 28